import querySo from "stores/route/query"
import { URL_PAR } from "stores/route/utils/types"
import { Cycle } from "types/Cycle"
import { DateRange } from "types/global"
import { dateWithoutTime, haveValueDateRange, overlapDateRange, urlToDateRange } from "utils"
import { CYCLE_STATUS } from "../types"
import { getCycleStatus, getLayersInHarvest } from "./cycle"



/** restituisce i CYCLES filtrati secondo parametri */
export function getCycleFiltered(
	cycles: Cycle[], txt?: string, dateRange?: DateRange, growUnitId?: number, cropId?: number, 
	noPlanned?: boolean, noRunning?: boolean, noHarvested?: boolean, rejected?: boolean
): Cycle[] {

	cycles = cycles.filter(cycle => {

		if (haveValueDateRange(dateRange)) {
			const cycleRange = { start: dateWithoutTime(cycle.seedingDate), end: dateWithoutTime(cycle.harvestingDate) }
			if (!overlapDateRange(cycleRange, dateRange)) return false
		}

		if (!!growUnitId && cycle.growUnitId != growUnitId) return false
		if (!!cropId && cycle.cropLots.every(cl => cl.cropId != cropId)) return false

		const text = !txt || txt.length == 0
			// se txt c'e' nel nomde del CROP-LOT o nel sui codice
			|| cycle.cropLots?.some(cl => cl.cropName?.toLowerCase().includes(txt) || cl.lotCode?.includes(txt))
			// se txt c'e' nel uuid del CYCLE
			|| cycle.cycleUuid?.toLowerCase().includes(txt)
		if (!text) return false

		const status = getCycleStatus(cycle)
		if (
			(status == CYCLE_STATUS.PLANNED && noPlanned)
			|| (status == CYCLE_STATUS.RUNNING && noRunning)
			|| (status == CYCLE_STATUS.HARVESTED && noHarvested)
			|| (status == CYCLE_STATUS.REJECTED && !rejected)
		) return false

		return true
	})

	return cycles
}

/** get filtered/sorted CYCLE (for TABLE!) */
export function getCycleFilteredUrl(cycles: Cycle[]): Cycle[] {

	let [txt, dateRangeUrl, growUnitUrl, cropIdUrl, status] = querySo
		.getSearchUrl([URL_PAR.TEXT, URL_PAR.DATE_SEL, URL_PAR.GROWUNIT_SEL, URL_PAR.CROP_SEL, URL_PAR.CYCLE_STATUS])

	const cropId = cropIdUrl ? +cropIdUrl : null
	txt = txt?.trim().toLowerCase()
	let dateRange = urlToDateRange(dateRangeUrl)
	//if (daysDuration(dateRange) == 0) dateRange = null
	let statusSel = (status?.split("-") ?? []).map ( i => statusAll[+i] ) // [ "PLANNED", "RUNNING", "HARVESTED", "REJECTED" ]
	if ( statusSel.length == 0 ) statusSel = statusDefault

	let filtered = getCycleFiltered(
		cycles, txt, dateRange, +growUnitUrl, cropId, 
		!statusSel.includes("PLANNED"),
		!statusSel.includes("RUNNING"),
		!statusSel.includes("HARVESTED"),
		statusSel.includes("REJECTED")
	)

	filtered = querySo.getSorted({
		items: filtered,
		map: {
			status: c => getCycleStatus(c),
			layers: c => getLayersInHarvest(c),
			yield: c => c.yield ?? c.plannedYield,
		},
		sortNameDefault: "seedingDate",
		orderDefault: true,
	})

	return filtered
}

/**
 * tutti gli STATUS dei CYCLES 
 */
export const statusAll = [
	"PLANNED",
	"RUNNING",
	"HARVESTED",
	"REJECTED"
];

/**
 * STATUS di default dei CYCLES
 */
export const statusDefault = [
	"PLANNED",
	"RUNNING",
	"HARVESTED"
];

/**
 * restituisce se la configurazione degli stati è quella di default
 */
export const getIsDefault = (selected: string[]) => 
	!selected || selected.length == 0
	|| (statusDefault.length == selected.length && statusDefault.every(s => selected.includes(s)));
